import { NoThemeLoader } from "components/layout/ApplicationLoader";
import React from "react";

export const Authenticating = () => <NoThemeLoader />;
